<template>
    <div class="certificates">
      <div class="contents">
        <div class="pageBox waps ">
          <div class="products-centers">
            <div class="items" v-for="(val, index) in product" :key="index" :class="{'itemsLeft':parseInt((index+1))%2!=0,'itemsLefts':parseInt((index+1))%4==1}">
              <div class="bo">
                <el-image :src="baseUrl+val.image" :preview-src-list=[baseUrl+val.image]></el-image>
              </div>
              <div class="title">{{val.title}}</div>
            </div>
          </div>
          <div class="el-pages">
            <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
              :page-size="pageSize" layout="prev,pager,next" :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  //import NavHeaders from "@/components/NavHeaders.vue";
  import NavFooter from "@/components/NavFooter.vue";
  export default {
    name: 'product',
    data() {
      return {
        newType: 1,
        dialogVisible:false,
  
        baseUrl:'http://yingcheng.0576hs.com',
        id: this.$route.params.id,
        Factorys: [],
        currentPage: 1, // 当前页码
        pageSize: 8, // 每页显示的行数
        total: 0,
  
        showSlide: '', //控制动画效果
        list: [
          {}, {}, {}, {}, {}, {},{},{}
        ],
        product: [
  
        ], 
      };
    },
    components: {
      NavHeaders: () => import('@/components/NavHeaders.vue'),
      NavFooter,
    },
    mounted() {
      this.getProductList();
      this.$nextTick(() => {
        this.handleAnimate()//初始化第一次加载时在视口内就执行动画
        addEventListener('scroll', this.handleAnimate);
      })
    },
  
    destroyed() {
      removeEventListener('scroll', this.handleAnimate);
    },
    created() {
      document.documentElement.scrollTop = "0px";
      setTimeout(this.handleAnimate, 1000);
    },
    methods: {
      handleClose(){
        this.$refs.videoPlayer.player.pause();
        this.dialogVisible=false
      },
      changeNew(val) {
        let self = this
        self.newType = val
        self.id = val
        self.getProductList()
      },
      handleAnimate() {
        let top = pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        let vh = document.documentElement.clientHeight;
        let dom = document.querySelectorAll(".animate");
        [].slice.call(dom).forEach(v => {
          if (top + vh > v.offsetTop) {
            var delay = v.dataset.delay;
            if (delay) {
              setTimeout(() => {
                v.style.opacity = 1;
                v.classList.add(v.dataset.ani)
              }, delay)
            } else {
              v.style.opacity = 1;
              v.classList.add(v.dataset.ani)
            }
          } else {
            v.classList.remove(v.dataset.ani)
            v.style.opacity = 0;
          }
        })
      },
      handleCurrentChange(e) {
        let id = '14';
        this.currentPage = 1
        this.$api.mall.getCertificate({ limit: 12, page: e }).then((res) => {
          this.product = res.data.data.data;
          this.current_page = res.data.data.current_page
          this.total = res.data.data.total
        });
      },
      // 获取商品信息
      getProductList() {
        let id = '14';
        this.currentPage = 1
        this.$api.mall.getCertificate({  limit: 12, page: 1 }).then((res) => {
          this.product = res.data.data.data;
          this.current_page = res.data.data.current_page
          this.total = res.data.data.total
        });
      },
      // 购买
      buy(val) {
        this.dialogVisible=true
        val=this.product[0]
        this.playerOptions.sources[0].src=val.file
        this.playerOptions.poster=val.image
        //let id = this.$route.params.id;
       // this.$router.push(`/newdetail/${val}`);
      },
      // 打开视频
      openVideo() {
        this.showSlide = 'slideDown';
      },
      // 关闭视频
      closeVideo() {
        this.showSlide = 'slideUp';
        setTimeout(() => {
          this.showSlide = '';
        }, 600);
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  @media screen and (min-width: 0px) and (max-width:440px) {
  .certificates {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;
  
    //animate classs
    .animate {
      opacity: 0;
    }
  
    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }
  
    .rollIn {
      animation: rollIn 1s;
    }
  
    .slideInRight {
      animation: slideInRight 1s;
    }
  
    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }
  
    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }
  
    .el-pages {
      text-align: center;
      width: 100%;
      margin: 50px auto;
      overflow: hidden;
    }
  
    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
  
      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }
  
      .products-leixing {
        width: 288px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;
  
        .active {
          color: #00959b;
        }
  
        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }
  
      .products-centers {
        width: 90%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        .items:hover{
            .title{
               border-bottom: 4px solid #00959b;
             }
          }
        .itemsLeft{
          margin-left: 0px !important;
        }
        .items{
          width:48%;
          float: left;
          overflow: hidden;
          cursor: pointer;
          padding-bottom:20px;
          margin-left: 4%;
          box-sizing: border-box;
          
          .title{
            color: #fff;
            width: 100%;
            overflow: hidden;
            
            margin: 0px auto;
            padding: 10px;
            background: #fff;
            font-size: 20px;
            text-align: left;
            box-sizing: border-box;
  
            color: #252525;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .bo{
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            border-bottom: 1px solid #676767;
            box-sizing: border-box;
            position: relative;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  
    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }
  
    .v-enter-active {
      transition: all 1s ease;
    }
  
    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
  
      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;
  
        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          overflow: hidden;
  
          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }
  
          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }
  
    .contents {
      width: 100%;
      min-width: 0px;
      overflow: hidden;
      margin: 0px auto;
      padding-top:61px;
  
    }
  }
}

@media screen and (min-width: 1024px) and (max-width:1600px) {
.certificates {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;
  
    //animate classs
    .animate {
      opacity: 0;
    }
  
    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }
  
    .rollIn {
      animation: rollIn 1s;
    }
  
    .slideInRight {
      animation: slideInRight 1s;
    }
  
    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }
  
    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }
  
    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }
  
    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
  
      .products-nav-centers {
        position: relative;
        width: 1200px;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }
  
      .products-leixing {
        width: 288px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;
  
        .active {
          color: #00959b;
        }
  
        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }
  
      .products-centers {
        width: 1200px;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        //column-count: 4;
        //column-gap: 35px;
        .items:hover{
            .title{
               border-bottom: 4px solid #00959b;
             }
          }
          .itemsLefts{
            margin-left: 0% !important;
          }
        .items{
          width: 23.5%;
          overflow: hidden;
          height: 616px;
          cursor: pointer;
          float: left;
          padding-bottom: 50px;
          margin-left: 2%;
          box-sizing: border-box;
          
          .title{
            color: #fff;
            width: 100%;
            overflow: hidden;
            
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 25px;
            padding-left: 50px;
            padding-right: 50px;
            background: #fff;
            font-size: 20px;
            text-align: left;
            box-sizing: border-box;
  
            color: #252525;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .bo{
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            border-bottom: 1px solid #676767;
            box-sizing: border-box;
            position: relative;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  
    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }
  
    .v-enter-active {
      transition: all 1s ease;
    }
  
    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
  
      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;
  
        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          overflow: hidden;
  
          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }
  
          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }
  
    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;
  
    }
  }


}
@media screen and (min-width: 1600px) and (max-width:8000px) {
  .certificates {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;
    background: #ededed;
  
    //animate classs
    .animate {
      opacity: 0;
    }
  
    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }
  
    .rollIn {
      animation: rollIn 1s;
    }
  
    .slideInRight {
      animation: slideInRight 1s;
    }
  
    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }
  
    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }
  
    .el-pages {
      text-align: center;
      width: 100%;
      margin: 85px auto;
      overflow: hidden;
    }
  
    .pageBox {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
  
      .products-nav-centers {
        position: relative;
        width: 100%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
        background: #fff;
        text-align: center;
      }
  
      .products-leixing {
        width: 288px;
        font-size: 16px;
        color: #252525;
        //color: #00959b;
        overflow: hidden;
        margin: 50px auto;
        padding: 0px;
        box-sizing: border-box;
  
        .active {
          color: #00959b;
        }
  
        span:hover {
          color: #00959b;
          cursor: pointer;
        }
      }
  
      .products-centers {
        width: 1600px;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px 0px 0px 0px;
        //column-count: 4;
        //column-gap: 35px;
        .items:hover{
            .title{
               border-bottom: 4px solid #00959b;
             }
          }
          .itemsLefts{
            margin-left: 0% !important;
          }
        .items{
          width: 23.5%;
          overflow: hidden;
          height: 616px;
          cursor: pointer;
          float: left;
          padding-bottom: 50px;
          margin-left: 2%;
          box-sizing: border-box;
          
          .title{
            color: #fff;
            width: 100%;
            overflow: hidden;
            
            margin: 0px auto;
            padding-top: 30px;
            padding-bottom: 25px;
            padding-left: 50px;
            padding-right: 50px;
            background: #fff;
            font-size: 20px;
            text-align: left;
            box-sizing: border-box;
  
            color: #252525;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .bo{
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            border-bottom: 1px solid #676767;
            box-sizing: border-box;
            position: relative;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  
    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }
  
    .v-enter-active {
      transition: all 1s ease;
    }
  
    .in-banner {
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      padding: 0px;
      box-sizing: border-box;
      position: relative;
      color: #fff;
  
      .p-nav {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        top: 0px;
  
        .p-title {
          width: 188px;
          margin: 0px auto;
          box-sizing: border-box;
          padding: 0px;
          text-align: center;
          overflow: hidden;
  
          .p-1 {
            font-size: 40px;
            color: #fff;
            font-weight: 600;
          }
  
          .p-2 {
            color: #0299a5;
            font-size: 16px;
            margin-top: 8px;
            line-height: 28px;
          }
        }
      }
    }
  
    .contents {
      width: 100%;
      min-width: 1350px;
      overflow: hidden;
      margin: 0px auto;
      padding-top: 75px;
  
    }
  }
}
  </style>